import React from 'react'

import * as S from './select.styled'

interface SelectOptionButtonProps {
  onClick: (e: React.MouseEvent) => void
}

export const SelectOptionButton: React.FC<SelectOptionButtonProps> = ({ onClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <S.SelectOptionButton type="button" onClick={handleClick}>
      Move
    </S.SelectOptionButton>
  )
}
